import { intervalToDuration, isAfter } from 'date-fns';

export const formatExpiryDate = (date) => {
    const now = new Date();
    const target = new Date(date);
    const isInFuture = isAfter(target, now);

    const duration = intervalToDuration({
      start: isInFuture ? now : target,
      end: isInFuture ? target : now,
    });

    const { months, days } = duration;

    const monthPart = months > 0 ? `${months} month${months > 1 ? 's' : ''}` : '';
    const dayPart = days > 0 ? `${days} day${days > 1 ? 's' : ''}` : '';
    const timePart = [monthPart, dayPart].filter(Boolean).join(' and ');

    if (!timePart) return isInFuture ? 'Expires today' : 'Expired today';

    return isInFuture
      ? `Expires in ${timePart}`
      : `Expired ${timePart} ago`;
  };